import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor(private toasterService: ToastrService) {
  }

  validate(services) {
    for (const index in services) {
      if (services.hasOwnProperty(index)) {
        let methodName = services[index];
        if (this[methodName]) {
          this[methodName]();
        }
      }
    }
  }

  cardFormat() {
    $('input.card_number').payment('formatCardNumber');
    $('input.card_expiry').payment('formatCardExpiry');
  }

  validateCc() {
    return $.validator.addMethod('validate_cc', function (value, element) {
      return $.payment.validateCardNumber(value);
    }, 'Please enter valid card number');
  }

  validateExpiry() {
    $.validator.addMethod('validate_expiry', function (value, element) {
      const expiry = value.split('/');
      return $.payment.validateCardExpiry(expiry[0], expiry[1]);
    }, 'Please enter valid expiry date');
  }

  checkValidCVV() {
    $('.card_cvv').keypress(function (event) {
      const $this = $(this);
      if (((event.which < 48 || event.which > 57))) {
        event.preventDefault();
      }
    });
  }

  /*
    * On image file upload check validation for supported extension
    */
  validateFileUpload(event: any, fubauto) {
    let supported = ["image/jpeg", "image/png", "image/svg+xml", "image/webp"];
    if (!supported.includes(event.files[0].type)) {

      this.toasterService.error('Invalid file uploaded. Allowed file types are jpg, jpeg, png and svg.');
      return false;
    }
    if (event.files[0].size > fubauto.maxFileSize) {

      this.toasterService.error('Uploaded file is too large.');
      return false;
    }
  }

}
